import { generatePaymentLinkWithNewFormat, generatePaymentLinkPhonePeWithNewFormat } from '../services/userService';
import { PLAN_PRICING } from '../services/SubscriptionPrices';

export interface PaymentPlan {
    plan: 'Plus' | 'Pro' | 'Topup';
    billingPeriod: string;
    userId: string;
}

/**
 * Shared payment handler for both Subscription and UpgradePlans components
 */
export const handlePaymentWithCurrency = async (
    currency: 'USD' | 'INR',
    paymentPlan: PaymentPlan
): Promise<string> => {
    const { plan, billingPeriod, userId } = paymentPlan;

    // Generate service type format: planType_duration (e.g., "plus_monthly", "pro_4months")
    const serviceType = `${plan.toLowerCase()}_${billingPeriod === '4month' ? '4months' : billingPeriod}`;

    // Get the amount based on plan and billing period
    const planKey = `${plan.toLowerCase()}_${billingPeriod === '4month' ? '4months' : billingPeriod}` as keyof typeof PLAN_PRICING;
    const planData = PLAN_PRICING[planKey];
    const amount = currency === 'USD' ? planData.usd : planData.inr;

    try {
        if (currency === 'USD') {
            const { paymentLink } = await generatePaymentLinkWithNewFormat(serviceType, userId, amount);
            return paymentLink;
        } else {
            const { paymentLink } = await generatePaymentLinkPhonePeWithNewFormat(serviceType, userId, amount);
            return paymentLink;
        }
    } catch (error) {
        console.error('Payment error:', error);
        throw new Error('Failed to generate payment link. Please try again.');
    }
};
